"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECommunityInvestment = void 0;
exports.ECommunityInvestment = {
    reinvestment_of_equity: "reinvestment_of_equity",
    mutual_funds: "mutual_funds",
};
